import React from "react";
import { motion } from "framer-motion";

/**
 * EditorialMarquee — single slow-moving row of large serif words.
 * Uses framer-motion for infinite horizontal motion.
 */
export default function EditorialMarquee({
    words = [
        "Hypnotherapy",
        "Breathwork",
        "Constellation",
        "Sound Healing",
        "Inner Child",
        "Soul Contract",
        "Nervous System",
        "Feminine Wellness",
    ],
    duration = 42,
    className = "",
}) {
    const doubled = [...words, ...words];
    return (
        <div
            className={`relative overflow-hidden py-10 lg:py-14 border-y border-[#EFEBE4] bg-[#FAF8F5] ${className}`}
            data-testid="editorial-marquee"
        >
            <motion.div
                className="flex whitespace-nowrap"
                animate={{ x: ["0%", "-50%"] }}
                transition={{
                    duration,
                    ease: "linear",
                    repeat: Infinity,
                }}
            >
                {doubled.map((w, i) => (
                    <span
                        key={i}
                        className="font-serif italic text-4xl sm:text-5xl lg:text-6xl text-[#2C2B29] px-8 lg:px-14 leading-none"
                    >
                        {w}
                        <span
                            className="mx-4 lg:mx-6 text-[#A68A6B] not-italic font-serif"
                            aria-hidden="true"
                        >
                            ✦
                        </span>
                    </span>
                ))}
            </motion.div>
        </div>
    );
}
